import { createStoreCreator } from 'lib/store'
import reducer from 'reports/scrapTrend/reducers'

export default createStoreCreator(reducer)
